import styled from "styled-components";

export const Banner = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr) 1.5fr;
  align-items: center;
  gap: clamp(20px, 3vw, 60px);
  width: 100%;
  padding: 10px;
  background: #FFF;

  @media (max-width: 900px) {
    gap: 10px;
    padding: 10px 10px;
  }

  @media (max-width: 480px) {
    gap: 5px;
    padding: 10px 10px;
  }
`;

export const BannerItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;

export const Logo = styled.img`
  display: block;
  width: auto;
  max-width: 100%;
  height: clamp(50px, 5vw, 85px);
  object-fit: contain;

  @media (max-width: 900px) {
    height: clamp(48px, 9vw, 70px);
  }

  @media (max-width: 480px) {
    height: clamp(42px, 13vw, 58px);
  }
`;

export const EuItem = styled(BannerItem)`
  gap: clamp(5px, 1.5vw, 24px);
`;